import { useState, useEffect } from "react";
import Button from "../../../../Custom/Button/Button";
import dokumentaZaposlenihImg from "../../../../../picture/dokumenta-zaposlenih.png";
import PretragaZaposlenih from "./PretragaZaposlenih";
import DodavanjeZaposlenog from "./DodavanjeZaposlenog";
import { useGlobalContext } from "../../../../../Context/Context";

function ShowBarDokumentaZaposlenih() {
  const [currentMode, setCurrentMode] = useState("AKTIVNI");
  const [currentState, setCurrentState] = useState("");

  const { editZaposlenData } = useGlobalContext();

  useEffect(() => {
    const onSync = (e) => {
      const mode = e?.detail?.mode;
      if (mode) setCurrentMode(mode);
    };
    window.addEventListener("zaposleniViewSync", onSync);
    return () => window.removeEventListener("zaposleniViewSync", onSync);
  }, []);

  useEffect(() => {
    setCurrentState(editZaposlenData ? "EDIT" : "");
  }, [editZaposlenData]);

  const handleModeClick = (mode) => {
    setCurrentMode(mode);
    setCurrentState("");
    window.dispatchEvent(
      new CustomEvent("zaposleniViewChange", { detail: { mode } })
    );
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          padding: "10px"
        }}
      >
        <img src={dokumentaZaposlenihImg} style={{ width: "60%" }} />
      </div>

      <div style={{ height: "500px", overflowY: "auto" }}>
        {currentState === "" && (
          <>
            <div onClick={() => handleModeClick("AKTIVNI")}>
              <Button
                active={currentMode === "AKTIVNI"}
                style={{ fontWeight: "bold", minHeight: "50px" }}
              >
                АКТИВНИ ЗАПОСЛЕНИ
              </Button>
            </div>
            <div onClick={() => handleModeClick("EKSTERNI")}>
              <Button
                active={currentMode === "EKSTERNI"}
                style={{ fontWeight: "bold", minHeight: "50px" }}
              >
                ЕКСТЕРНИ ЗАПОСЛЕНИ
              </Button>
            </div>
            <div onClick={() => handleModeClick("ARHIVIRANI")}>
              <Button
                active={currentMode === "ARHIVIRANI"}
                style={{ fontWeight: "bold", minHeight: "50px" }}
              >
                АРХИВИРАНИ ЗАПОСЛЕНИ
              </Button>
            </div>
            <div onClick={() => setCurrentState("dodavanje")}>
              <Button style={{ fontWeight: "bold", minHeight: "50px" }}>
                ДОДАВАЊЕ ЗАПОСЛЕНИХ
              </Button>
            </div>
            <div onClick={() => setCurrentState("pretraga")}>
              <Button style={{ fontWeight: "bold", minHeight: "50px" }}>
                ПРЕТРАГА ЗАПОСЛЕНИХ
              </Button>
            </div>
          </>
        )}

        {(currentState === "dodavanje" || editZaposlenData) && (
          <DodavanjeZaposlenog
            setCurrentState={setCurrentState}
            editZaposlenData={editZaposlenData}
          />
        )}

        {currentState === "pretraga" && (
          <PretragaZaposlenih onClose={() => setCurrentState("")} />
        )}
      </div>
    </div>
  );
}

export default ShowBarDokumentaZaposlenih;
